import React, { useState } from 'react';

interface TeamLogoProps {
  abbrev: string;
  size?: number;
}

export const TeamLogo: React.FC<TeamLogoProps> = ({ abbrev, size = 56 }) => {
  const logoUrl = `https://assets.nhle.com/logos/nhl/svg/${abbrev}_light.svg`;
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {imgFailed ? (
        /* Fallback badge — only shown when SVG fails to load */
        <div
          className="rounded d-flex align-items-center justify-content-center fw-bold text-white"
          style={{
            width: '100%',
            height: '100%',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            fontSize: `${Math.max(size * 0.28, 9)}px`,
          }}
        >
          {abbrev}
        </div>
      ) : (
        <img
          src={logoUrl}
          alt={`${abbrev} logo`}
          width={size}
          height={size}
          style={{ objectFit: 'contain' }}
          onError={() => setImgFailed(true)}
        />
      )}
    </div>
  );
};
